export const editedText = (value)=>typeof value === 'string' ? value : '';
